import { IMucThuTamThuSinhVienViewModel } from "../../../model/respone/chung-tu-tam-thu/IMucThuTamThuSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IMucTamThuBySinhVienType<T> {
  id_sv: string;
  data: T;
}

export const eMucThuTamThuActionsObj = {
  LOAD_MUC_THU_LOAD_START: "",
  LOAD_MUC_THU_LOAD_SUCCESS: {} as IMucTamThuBySinhVienType<
    IMucThuTamThuSinhVienViewModel[]
  >,
  LOAD_MUC_THU_LOAD_ERRR: "",

  LOAD_SO_TIEN_CON_LAI_LOAD_START: "",
  LOAD_SO_TIEN_CON_LAI_LOAD_SUCCESS: {} as IMucTamThuBySinhVienType<number>,
  LOAD_SO_TIEN_CON_LAI_LOAD_ERRR: "",
};
export const eMucThuTamThuActionIds = generateActionTypeIds(
  eMucThuTamThuActionsObj,
  "MUC_THU_TAM_THU"
);
export type IMucThuTamThuActionTypes = IGenericActionType<
  typeof eMucThuTamThuActionsObj,
  "MUC_THU_TAM_THU"
>;
